import { put, takeLatest } from "redux-saga/effects";
import { requestdueDetailsAndDueDetailsBreakupReportsList } from "services/acclgl/reports/dueDetailsAndBreakupReport";
import {
    fetchDueDetailsAndDueDetailsBreakupReportsListRequest,
  fetchDueDetailsAndDueDetailsBreakupReportsListSuccess,
  fetchDueDetailsAndDueDetailsBreakupReportsListFailure,
} from "redux/reducers/acclgl/reports/dueDetailsAndBreakupReport";
export function* watchDueDetailsAndDueDetailsBreakupReportsSaga() {
  yield takeLatest(fetchDueDetailsAndDueDetailsBreakupReportsListRequest, fetchDueDetailsAndDueDetailsBreakupReportsList);
}

function* fetchDueDetailsAndDueDetailsBreakupReportsList({ payload }) {
  try {
    const response = yield requestdueDetailsAndDueDetailsBreakupReportsList(payload);
    yield put(fetchDueDetailsAndDueDetailsBreakupReportsListSuccess(response));
  } catch (error) {
    yield put(
        fetchDueDetailsAndDueDetailsBreakupReportsListFailure("Failed to get list of due details reports")
    );
  }
}
